import { useRef, useCallback, useEffect } from 'react';
import { get } from 'lodash';
import { useLocation } from 'react-router-dom';

const useStaticPropsGuard = (props, staticPropKeys, contextName = '') => {
  const propsRef = useRef(props);
  const staticPropsChanged = staticPropKeys.some(propKey => get(propsRef.current, propKey) !== get(props, propKey));
  if (staticPropsChanged) {
    throw new Error(`${contextName && `[${contextName}] `}Don't modify props like ${staticPropKeys.join(', ')}!`);
  }
  propsRef.current = props;
};

function useClickOutside(ref, callback) {
  const cbRef = useRef(callback);
  cbRef.current = callback;
  const handleClick = useCallback(e => {
    const el = ref.current;
    const handler = cbRef.current;
    if (!el || el.contains(e.target)) {
      return;
    }
    handler === null || handler === void 0 ? void 0 : handler(e);
  }, [ref]);
  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
}
// export default useClickOutside;

function useResetScrollOnPageLoad() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
}

export { useClickOutside, useResetScrollOnPageLoad, useStaticPropsGuard };
